import { SIDEBAR_NAMES } from 'common/activeElements/sidebars/sidebarsNames';
import WorkAssignmentDetails from 'common/activeElements/sidebars/WorkAssignmentDetails';

export const PAGE_KEY = 'RideListPage';

export const makeActiveElementsConfig = () => [
	{
		name: SIDEBAR_NAMES.waDetails,
		Component: (props) => <WorkAssignmentDetails {...props} />,
	},
];
